import { useQuery } from '@tanstack/react-query';

import { getAdminForm } from '@entities/adminConversationUserHistory/api/handlers/getAdminForm';
import { IUserHistoryRow } from '@entities/adminConversationUserHistory/model/types';
import { keysToCamel } from '@shared/helpers';

export function useGetAdminFormQuery(id: number) {
    const { data, isLoading, isPending } = useQuery({
        queryKey: ['adminForm', id],
        queryFn: () => getAdminForm(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        select: (data) => keysToCamel<IUserHistoryRow[]>(data?.data),
    });

    return { data, isLoading, isPending };
}
